import { render, staticRenderFns } from "./Amenities.vue?vue&type=template&id=c846892a&scoped=true&"
import script from "./Amenities.vue?vue&type=script&lang=js&"
export * from "./Amenities.vue?vue&type=script&lang=js&"
import style0 from "./Amenities.vue?vue&type=style&index=0&id=c846892a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c846892a",
  null
  
)

export default component.exports